import { useState } from 'react';
import Dropzone from 'react-dropzone';
import { toast } from 'react-toastify';
import { apiFetch } from '../../api/api';
import { getVideoDuration } from '../../utils/media/getVideoDuration';
import { useOrg } from '../../pages/orgs/org-context';


const MAX_VIDEO_SECONDS = 15;




const UploadMediaPanel = ({ onUploaded, datasetId=null, dataDocId=null }) => {
  const [uploading, setUploading] = useState(false);
  const { activeOrgId } = useOrg();
  const [publicUrl, setPubicUrl] = useState("");


  const handleDrop = async (files) => {
    if (!activeOrgId) {
      toast.error('Please select an organization before uploading media');
      return;
    }
    const file = files[0];
    if (!file) return;

    const isVideo = file.type.startsWith('video');
    const type = isVideo ? 'video' : 'image';

    // 1️⃣ Client-side validation
    if (isVideo) {
      const duration = await getVideoDuration(file);
      // if (duration > MAX_VIDEO_SECONDS) {
      //   toast.error('Videos must be 15 seconds or less');
      //   return;
      // }
    }

    setUploading(true);

    try {
      // 2️⃣ Ask backend for signed upload URL
      const { uploadUrl, bucket, key } = await apiFetch('/media/upload-url', {
        method: 'POST',
        body: {
          mimeType: file.type,
          originalName: file.name,
        }
      });



      // 3️⃣ Upload directly to S3
      await fetch(uploadUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': file.type
        },
        body: file
      });

      if (!activeOrgId) {
         throw new Error('Missing orgId for media upload');
      }


      // 4️⃣ Create media record in backend
       await apiFetch('/media', {
         method: 'POST',
         body: {
           orgId: activeOrgId,     // 🔴 REQUIRED
           datasetId,
           dataDocId,
           type,
           s3Key: key,
           s3Bucket: bucket,
           mimeType: file.type,
           originalName: file.name,
           size: file.size
         }
       });
      let mediaUrl = `https://${bucket}.s3.amazonaws.com/${key}`;
      setPubicUrl(mediaUrl);

      toast.success('Media uploaded');
      onUploaded?.();

    } catch (err) {
      console.error(err);
      toast.error('Upload failed');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="upload-panel-vertical">

      {/* Dropzone */}
      <Dropzone
        onDrop={handleDrop}
        multiple={false}
        disabled={!activeOrgId}
        accept={{
          'image/*': []
        }}
      >
        {({ getRootProps, getInputProps }) => (
          <div {...getRootProps()} className="dropzone">
            <input {...getInputProps()} />
            {uploading ? 'Uploading…' : 'Click or drop image'}
          </div>
        )}
      </Dropzone>

      {/* Preview */}
      {publicUrl && (
        <div className="upload-preview">
          <img
            src={publicUrl}
            alt="Preview"
          />
        </div>
      )}

    </div>

  );


};

export default UploadMediaPanel;
